import { render, staticRenderFns } from "./HistoryMeet.vue?vue&type=template&id=01987ed0"
import script from "./HistoryMeet.vue?vue&type=script&lang=js"
export * from "./HistoryMeet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports